import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import AboutHero from "../sections/AboutHero";
import WhyClarity from "../sections/WhyClarity";
import CapabilitiesSection from "../sections/CapabilitiesSection";
import EngineDiagram from "../sections/EngineDiagram";
import PrincipleBand from "../sections/PrincipleBand";
import AboutVision from "../sections/AboutVision";
import AboutClosing from "../sections/AboutClosing";

const AboutPage = () => (
    <div className="min-h-screen bg-ink text-white">
        <Seo
            title="About BuildEase | South Africa's Residential Construction Intelligence Platform"
            description="Discover BuildEase, South Africa's residential construction intelligence platform, helping homeowners gain greater clarity on construction plans, costs, quotations and building decisions."
        />
        <Navbar />
        <main>
            <AboutHero />
            <WhyClarity />
            <CapabilitiesSection />
            <EngineDiagram />
            <PrincipleBand />
            <AboutVision />
            <AboutClosing />
        </main>
        <Footer />
    </div>
);

export default AboutPage;
